import api from '.';
import { PipingListGroup } from '../pages/MasterData/PipingListGroup/pipingListGroupSlice';

interface ReturnTypePipingListGroup {
  data: PipingListGroup[];
}

export async function getPipingListGroups(): Promise<ReturnTypePipingListGroup> {
  const { data } = await api.get('/piping-list-groups');

  return data;
}
